import Layout from './components/layout';
import ImportCSV from './components/ImportCsv';

export default {
	Layout, ImportCSV
}